import React, { memo } from 'react';
import { connect } from 'react-redux';

import { createStateSelector } from '@/redux/actions/reservation/helper';
import { handleChannelDataChange } from '@/redux/actions/reservation/checkInEditor';
import { ReducerState, storeName } from '@/redux/reducers/reservation/checkInEditor';
import ChannelInfo from '@/pages/reservation/orderEditor/components/ChannelInfo';
import { getPopupContainer } from '@/pages/reservation/orderEditor/checkInEditor/helper';

// import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { channelInfo, channelList, strategyList, commonInfo, rentTimeInfo } = state;
  return {
    channelInfo,
    channelList,
    strategyList,
    occType: rentTimeInfo.occType,
    // 经过夜审次数大于0
    isThroughAudit: commonInfo.auditPassedCount > 0,
  };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  callChannelDataChange: handleChannelDataChange,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

/**
 * 经过夜审 或者 直连的渠道 渠道、策略不可修改
 * OTA渠道可修改渠道单号
 */
const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const {
    channelInfo,
    channelList,
    strategyList,
    callChannelDataChange,
    isThroughAudit,
    occType,
  } = props;

  return (
    <ChannelInfo
      value={channelInfo}
      channelList={channelList}
      strategyList={strategyList}
      onChange={callChannelDataChange}
      isThroughAudit={isThroughAudit}
      occType={occType}
      getPopContainer={getPopupContainer}
    />
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
